import { Loader2, Search } from "lucide-react";
import { Input } from "../../../../components/ui/common/input";

interface RecipeListSearchProps {
  value: string;
  onChange: (value: string) => void;
  isLoading?: boolean;
}

const RecipeListSearch = ({ value, onChange, isLoading = false }: RecipeListSearchProps) => (
  <div className="tw-mb-4">
    <div className="tw-relative tw-w-72">
      {isLoading ? (
        <Loader2 className="tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-h-4 tw-w-4 tw-animate-spin tw-text-primary tw-pointer-events-none" />
      ) : (
        <Search className="tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-h-4 tw-w-4 tw-text-muted-foreground tw-pointer-events-none" />
      )}
      <Input
        placeholder="Search recipes..."
        value={value}
        onChange={event => onChange(event.target.value)}
        className="tw-pl-9"
      />
    </div>
  </div>
);

export default RecipeListSearch;
